import { SkeletonCard } from '../../../../components/Skeleton';
import styles from './PostTabSkeleton.module.scss';

export interface PostTabSkeletonProps {
  count?: number;
  className?: string;
}

export function PostTabSkeleton({ count = 5, className }: PostTabSkeletonProps) {
  const classes = [styles.postTabSkeleton, className].filter(Boolean).join(' ');

  return (
    <div className={classes} aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

export default PostTabSkeleton;
